import { DatePipe, DecimalPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DetailDocumentsComponent } from 'src/app/shared/components/detail-documents/detail-documents.component';
import { FEASIBILITY_KEYS } from 'src/app/shared/constants/common.constants';
import { DOCUMENT_NAMES_TO_REMOVE } from 'src/app/shared/constants/standard-documents-constants';
import { UtilsService } from 'src/app/utils/utils.service';
import { StandardRequestDetailService } from '../standard-request-detail.service';
import { StandardRequestDetailDocumentsService } from './standard-request-detail-documents.service';

@Component({
    selector: 'app-standard-request-detail-documents',
    templateUrl: './standard-request-detail-documents.component.html',
    styleUrls: ['./standard-request-detail-documents.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        Button,
        TooltipModule,
        AccordionModule,
        NgFor,
        DecimalPipe,
        TranslateModule,
        DatePipe,
        NgClass,
        TooltipModule,
        DetailDocumentsComponent
    ]
})
export class StandardRequestDetailDocumentsComponent {

    protected readonly standardRequestDetailService = inject(StandardRequestDetailService);
    protected readonly standardRequestDetailDocumentsService = inject(StandardRequestDetailDocumentsService);
    protected readonly utilsService = inject(UtilsService);
    protected readonly translateService = inject(TranslateService);

    protected readonly documentNamesToRemove = DOCUMENT_NAMES_TO_REMOVE;
    protected readonly feasibilityKeys: string[] = FEASIBILITY_KEYS;
    protected readonly odRatingCells: string[] = ['VERY_LOW', 'LOW', 'GOOD', 'VERY_GOOD', 'EXCEPTIONAL'];

    isNumber(value: any): boolean {
	    return typeof value === 'number';
    }

    translate(value: any): string {
        if (!value && value !== false) return '';

        if (typeof value === 'boolean') {
            return this.utilsService.translateBoolean(value);
        } else if (typeof value === 'string') {
            return this.translateService.instant(value);
        }

        return value;
    }

    getClassFromValue(value: any) {
        if (typeof value === 'string') {
            return value.toLowerCase().replace(/_/g, '-');
        }
        return '';
    }

    applyOpacity(value1: any, value2: string) {
        return value1 !== value2;
    }
}
